import React from 'react';

const NotFoundPage = () => {
  return (
    <div>
      <h4>
        404 Page Not Found
      </h4>
    </div>
  );
};

export default NotFoundPage;



/** WEBPACK FOOTER **
 ** ./src/components/NotFoundPage.js
 **/